import React, { useEffect } from 'react';
import { HeroSection } from './sections/HeroSection';
import { initMetaPixel } from './utils/pixel';
import { PainSection } from './sections/PainSection';
import { ComparisonSection } from './sections/ComparisonSection';
import { MechanismSection } from './sections/MechanismSection';
import { CreatorSection } from './sections/CreatorSection';
import { ProductSection } from './sections/ProductSection';
import { PriceSection } from './sections/PriceSection';
import { TestimonialsSection } from './sections/TestimonialsSection';
import { GuaranteeSection } from './sections/GuaranteeSection';
import { FinalCtaSection } from './sections/FinalCtaSection';
import { StickyBanner } from './components/StickyBanner';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <>
      <StickyBanner data-id="element-0" />
      <main className="w-full min-h-screen bg-midnight text-warmwhite overflow-x-hidden selection:bg-rosegold/30 selection:text-warmwhite pt-10 md:pt-11" data-id="element-1">
        <HeroSection data-id="element-2" />
        <PainSection data-id="element-3" />
        <ComparisonSection data-id="element-4" />
        <MechanismSection data-id="element-5" />
        <CreatorSection data-id="element-6" />
        <ProductSection data-id="element-7" />
        <PriceSection data-id="element-8" />
        <TestimonialsSection data-id="element-9" />
        <GuaranteeSection data-id="element-10" />
        <FinalCtaSection data-id="element-11" />
      </main>
    </>;
}